export default __webpack_public_path__ + "0ec7f06d9ce95463456bba7d2a6af2f6.webp";